









import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      ready: false,
    };
  },
  props: {
    fullLoad: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loaderSpeed() {
      return {
        'animation-duration': `${this.speed}s`,
        'animation-name': 'dash',
        'animation-timing-function': 'linear',
        'animation-iteration-count': 100,
      };
    },
  },
  mounted() {
    this.ready = true;
    setTimeout(() => {
      this.ready = false;
    }, 1000);
  },
});
